<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="d-flex flex-column">
                    <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                        <b-col lg="3">
                            <p>Records Totali: {{ rows }}</p>
                        </b-col>

                        <b-col lg="9">
                            <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                        </b-col>
                    </b-row>
                </div>
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template #cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Visualizza Identity" variant="outline-secondary" @click="onClickViewIdentity(item)">
                                    <i class="bi bi-eye"></i>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Aggiorna Identity" variant="outline-success" @click="onClickEditIdentity(item)">
                                    <font-awesome-icon icon="edit"></font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Elimina Identity" variant="outline-danger" @click="onClickDeleteIdentity(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>

                <identity-manager-modal-edit-component ref="cmpIdentityManagerModalEdit" @deleteIdentity="loadDataIdentityManager" @onSave="loadDataIdentityManager" />
            </div>
            <div class="d-flex flex-column">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Records Totali: {{ rows }}</p>
                    </b-col>

                    <b-col lg="9">
                        <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import IdentityManagerModalEditComponent from "./IdentityManagerModalEditComponent.vue";
export default {
    components: { IdentityManagerModalEditComponent },
    data() {
        return {
            pathResource: "/identitymanager",
            items: [],
            rows: 0,
            perPage: 50,
            currentPage: 1,
            filtro: {},
            listKey: 0,
            fields: [
                {
                    label: "",
                    key: "index",
                },
                {
                    label: "Applicativo",
                    key: "applicationName",
                },
                {
                    label: "client-id",
                    key: "clientId",
                },
                {
                    label: "url request",
                    key: "urlRequest",
                },
                {
                    label: "url callback",
                    key: "urlCallback",
                },
                {
                    label: "otp",
                    key: "otp",
                },
                {
                    label: "creato da",
                    key: "createUser",
                },
                {
                    label: "data creazione",
                    key: "createDate",
                    formatter: (param) => {
                        return UtilityMixin.methods.formatDateTime(param);
                    },
                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],
        };
    },
    mixins: { UtilityMixin },
    mounted() {
        // let me = this;
    },
    watch: {
        currentPage() {
            this.loadDataIdentityManager();
        },
    },
    methods: {
        init() {
            let me = this;
            me.loadDataIdentityManager();
        },
        loadDataIdentityManager() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroIdentity"]) {
                me.filtro = JSON.parse(sessionStorage["filtroIdentity"]);
            }
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            me.items = [];
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataIdentityManagerSuccess, me.loadDataLettiError);
        },
        loadDataIdentityManagerSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.$emit("afterLoadData");
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
        },
        loadDataIdentityManagerError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onClickVisualizzaClient(item) {
            let me = this;
            me.$router.push("/rsagestionecamere/view/" + item.id);
        },
        onClickViewIdentity(item) {
            let me = this;
            let readOnly = true;
            me.$refs.cmpIdentityManagerModalEdit.show(item, readOnly);
        },
        onClickEditIdentity(item) {
            let me = this;
            let readOnly = false;
            me.$refs.cmpIdentityManagerModalEdit.show(item, readOnly);
        },
        onClickNuovoIdentity() {
            let me = this;
            me.$refs.cmpIdentityManagerModalEdit.show(
                {
                    id: null,
                    applicationName: null,
                    otp: null,
                    urlCallback: null,
                    urlRequest: null,
                },
                false
            );
        },
        onClickDeleteIdentity(item) {
            let me = this;
            me.$refs.cmpIdentityManagerModalEdit.onDeleteIdentity(item);
        },
    },
};
</script>

<style></style>
